// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-pdf-bar":"PdfBar_cost-saving-pdf-bar__gDUpT"};